import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useGetHelpQuery } from 'services/cms';
import theme from 'theme';

import HelpPageLayout from 'components/Help/HelpPageLayout';
import IsLoading from 'components/isLoading';

const LegalTermsScreen: React.FC = () => {
  const { data, isLoading } = useGetHelpQuery();

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <IsLoading />
      </View>
    );
  }

  if (!data) {
    // TODO: definir comportamento ao receber erros da API
    return null;
  }

  return (
    <HelpPageLayout title={data.termsConditions.title}>
      <View style={styles.container}>
        <Text style={styles.text}>{data.termsConditions.text}</Text>
      </View>
    </HelpPageLayout>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    paddingHorizontal: 16,
  },
  text: {
    color: theme.colors.base.white,
  },
});

export default LegalTermsScreen;
